<template>
  <app-child-dialog class="flex flex-none" color="blue">
    <template v-slot:dialogTitle> </template>
    <template v-slot:dialogContent>
      <memory-item-form-navigation color="blue" class="mr-8 mt-6">
        <template v-slot:tabContent>
          <memory-item-form></memory-item-form>
        </template>
      </memory-item-form-navigation>
    </template>
  </app-child-dialog>
</template>

<script>
import AppChildDialog from '@/components/ui/uiToda/AppChildDialogToda'
import MemoryItemFormNavigation from '@/components/layout/memoryToda/memoryItem/MemoryItemFormNavigation'
import MemoryItemForm from '@/components/layout/memoryToda/memoryItem/MemoryItemForm'

// import { useDialog } from "@/services/useDialog";

export default {
  name: 'MemoryFormDialog_TODA',

  components: {
    AppChildDialog,
    MemoryItemFormNavigation,
    MemoryItemForm,
  },

  setup() {},
}
</script>
<style lang="scss"></style>
